import template from './permissionsSelector.html';
import './permissionsSelector.scss';

export class PermissionsSelectorController {
  constructor() {
    this.selectedScopes = [];
    this.semiSelectedScopes = [];
    this.selectedScope = {};
  }
  $onInit() {
    this.scopes.forEach((scope) => {
      this._detectScopeSelection(scope, false);
    });
  }
  selectScope(scope) {
    this.selectedScope = scope;
  }
  toggleScope(scope) {
    const shouldSelectThem = this.semiSelectedScopes.includes(scope.id) ||
      !this.selectedScopes.includes(scope.id);

    scope.permissions
    .filter((permission) => {
      const isSaved = this.savedPermissions.includes(permission.id);
      return shouldSelectThem ? !isSaved : isSaved;
    })
    .forEach((permission) => {
      this.onToggle({
        permission,
        isSelected: !shouldSelectThem,
      });
    });

    this._detectScopeSelection(scope);
  }
  togglePermission(permission) {
    this.onToggle({
      permission,
      isSelected: this.savedPermissions.includes(permission.id),
    });
    this._detectScopeSelection(this.selectedScope);
  }
  _detectScopeSelection(scope, removeFirst = true) {
    if (removeFirst) {
      [
        this.selectedScopes,
        this.semiSelectedScopes,
      ].forEach((list) => {
        const index = list.indexOf(scope.id);
        if (index > -1) {
          list.splice(index, 1);
        }
      });
    }

    if (scope.permissions.length) {
      let hasAll = true;
      let atLeastOne = false;
      scope.permissions.forEach((permission) => {
        if (this.savedPermissions.includes(permission.id)) {
          atLeastOne = true;
        } else if (hasAll) {
          hasAll = false;
        }
      });

      if (hasAll) {
        this.selectedScopes.push(scope.id);
      } else if (atLeastOne) {
        this.semiSelectedScopes.push(scope.id);
      }
    }
  }
}

export default {
  controller: PermissionsSelectorController,
  template,
  bindings: {
    id: '@',
    scopes: '<',
    savedPermissions: '<',
    onToggle: '&',
    listHeight: '<',
  },
};
